<template>
  <wrapper>
    <template slot="before-menu">
      <back-point icon="chevron-left" to="dashboard">Zurück</back-point>
    </template>

    <template slot="navigation">
      <menu-point to="account.details">Stammdaten</menu-point>
      <menu-point to="account.contact">Ansprechpartner</menu-point>
    </template>

    <template slot="page">
      <router-view :agency="agency"></router-view>
    </template>
  </wrapper>
</template>
    
<script>
import accountClient from "@/api/merchant/account";
import Wrapper from "@/components/Wrapper";
import MenuPoint from "@/components/MenuPoint";
import BackPoint from "@/components/BackPoint";

//import eventsClient from '../../api/events'

export default {
  components: {
    MenuPoint,
    BackPoint,
    Wrapper
  },

  data() {
    return {
      agency: {}
    };
  },

  mounted() {
    this.loadAgency();
  },

  methods: {
    loadAgency() {
      this.agency = accountClient
        .show()
        .then(response => (this.agency = response.data.data));
    }
  }
};
</script>